import { H2, HeadingSize } from "components/atoms/Heading";
import { FC, useState } from "react";
import { StandardSection } from "../templates/StandardSection";
import styled from "styled-components";
import { P1 } from "components/atoms/Paragraph";
import Image from "next/legacy/image";
import { mobile, tablet } from "components/templates/Breakpoints";
import { color } from "@styles";

interface BenefitTableData {
  heading: string;
  name: string;
  text: string;
}

interface BenefitTableProps {
  title?: string;
  data: BenefitTableData[];
}

export const BenefitTable: FC<React.PropsWithChildren<BenefitTableProps>> = ({ title, data }) => {
  const [tab, setTab] = useState(0);
  return (
    <StyledStandardSection>
      <H2 size={HeadingSize.H1} pb="3.5rem" align="center">
        {title}
      </H2>
      <Container>
        <Ul>
          {data.map((benefit, index) => {
            return (
              <Li key={benefit.name} onClick={() => setTab(index)}>
                <Image
                  src={`/static/icons/${benefit.name}.svg`}
                  alt={benefit.name}
                  height={32}
                  width={32}
                />
                <P1 pt="0" color={tab === index ? "#956AFF" : "#5C5757"} bold>
                  {benefit.heading}
                </P1>
              </Li>
            );
          })}
        </Ul>
        <RightContainer>
          <Spotlight>
            <Image
              src={`/static/icons/${data[tab].name}.svg`}
              alt={data[tab].name}
              width={64}
              height={64}
            />
            <P1 pt="1rem" bold fontSize="24px" color="#956AFF">
              {data[tab].heading}
            </P1>
            <P1>{data[tab].text}</P1>
          </Spotlight>
        </RightContainer>
      </Container>
    </StyledStandardSection>
  );
};

const Container = styled.div`
  background: ${color.B210};
  border: 2px solid #dfd3ff;
  box-shadow: 8px 8px 0px #eae1ff;
  border-radius: 8px;
  display: grid;
  max-width: 58rem;
  margin: 0 auto;
  grid-template-columns: 58.6fr 41.4fr;

  ${tablet} {
    max-width: 52.5rem;
    margin: auto;
    grid-template-columns: 48.5fr 51.5fr;
  }

  ${mobile} {
    padding: 0;
    grid-template-columns: 1fr;
    display: flex;
    flex-direction: column-reverse;
    box-shadow: none;
    border-radius: 0px;
  }
`;

const StyledStandardSection = styled(StandardSection)`
  ${mobile} {
    padding: 0;
  }
`;

const Li = styled.li`
  display: flex;
  gap: 1rem;
  align-items: center;
  padding: 0;
  margin: 1.5rem 2.5rem;
  cursor: pointer;

  ${tablet} {
    cursor: pointer;
  }

  ${mobile} {
    margin: 0 auto;
    padding-bottom: 1.5rem;
    cursor: pointer;
  }
`;

const Ul = styled.ul`
  margin: 2.5rem 0;

  ${mobile} {
    margin: 2.5rem 2.06rem 0 1.5rem;
    padding: 0 auto;
  }
`;

const RightContainer = styled.div`
  background: #ffffff;
  border-left: 2px solid #dfd3ff;
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;

  ${mobile} {
    border-left: none;
    border-bottom: 2px solid #dfd3ff;
    border-radius: 0;
  }
`;

const Spotlight = styled.div`
  background: #ffffff;
  margin: 2.83rem 2.5rem;

  ${mobile} {
    margin: 1.23rem 1.5rem 2.5rem 1.5rem;
    padding-top: 1.6rem;
  }
`;
